import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Switch, Button, Menu, Dropdown, Select } from 'antd';
import {
  SET_STAT_VIEW_MODE,
  TOGGLE_CREATE_EXERCISE_MODAL,
  TOGGLE_CREATE_USER_MODAL,
  TOGGLE_CREATE_WORKOUT_MODAL,
  TOGGLE_CREATE_ASSESSMENT_MODAL,
  TOGGLE_WORKOUT_PROGRAM_MODAL,
} from '../../ducks/Global/constants';
import {
  SET_IS_EXERCISE_EDIT,
  CLEAR_EDIT_EXERCISE,
} from '../../ducks/Exercise/constants';
import {
  CLEAR_EDIT_WORKOUT,
  SET_IS_WORKOUT_EDIT,
  RESET_WORKOUT_LOCAL_STATE,
} from '../../ducks/Workout/constants';
import { handleCarbCyclingModalOpen } from '../../ducks/CarbCycling/actions';
import './index.css';

const { Option } = Select;

class TitleSection extends React.Component {
  renderTitleSection = () => {
    const page = this.props.location.pathname || '';
    const pathMatch = page.match(/^\/dashboard\/workout\/workouts(\/\w+)?$/);
    const isAssessmentsPage = page === '/dashboard/admin/assessments' || page.startsWith('/dashboard/admin/assessments/');
    switch (page) {
      // V2 tool pages own their own headers via <PageHead>.
      case '/dashboard/tools/macro-calculator':
      case '/dashboard/tools/one-rep-max':
      case '/dashboard/tools/carb-cycling':
      case '/dashboard/tools/macro-history':
      case '/dashboard/tools/compliance':
        return true;
      case '/dashboard/coach/meal-plan':
        return {
          title: 'Nubod Coach',
          // subtitle:
          //   "Smart meal plans that adapt to your progress week by week.",
        };
      case '/dashboard/coach/food-preferences':
        return {
          title: 'Food Preferences',
          // subtitle:
          //   "After changing your food preferences, a notify coach button will enable. Make sure to notify your coach so changes can be made to your"
        };
      case '/dashboard/coach/shopping-list':
        return {
          title: 'Shopping List',
          // subtitle: "Sort your shopping list by aisle or recipe.",
        };
      case '/dashboard/nutrition/meal-plan':
        // V2 page owns its own header (NutritionPageV2). Returning `true`
        // collapses to null in render() so we don't double-stack titles.
        return true;
      case '/dashboard/nutrition/meal-plan/legacy':
        // Legacy custom meal-plan page now wraps in `.page` + PageHead;
        // suppress the legacy title here.
        return true;
      case '/dashboard/workout/workout-plans':
        // V2 page owns its own header (UserWorkoutPlansPage).
        return true;
      case '/dashboard/workout/workout-program':
        // V2 page owns its own header (UserWorkoutProgramsPage).
        return true;
      case '/dashboard/nutrition/food-preferences':
      case '/dashboard/nutrition/shopping-list':
        // V2 pages own their own headers via <PageHead>.
        return true;
      case '/dashboard/learn/nutrition':
        // LearnPage renders its own custom progress hero — suppress
        // the legacy header so they don't double-stack.
        return true;
      case '/dashboard/guides/diet':
        return {
          title: 'Diets',
          // subtitle:
          //   "Your will find everything you need to know about the diet type you selected right here.",
        };
      case '/dashboard/guides/eating-methods':
        return {
          title: 'Eating Methods',
          // subtitle:
          //   "Intermittent fasting is a popular eating pattern that can give you amazing results when done properly. Learn how to do it based on your macronutrient results.",
        };
      case '/dashboard/nutrition/recipes':
        // V2 page owns its own header (RecipesPage).
        return true;
      case '/dashboard/program':
        return {
          title: 'Program',
          // subtitle:
          //   "Always up to date with personalized recommendations based on your current macronutrient needs and goals.",
        };
      case '/dashboard/stats/progress':
        // V2 page owns its own header (StatsPageV2).
        return true;

      case '/dashboard/stats/exercise-history':
        // V2 page owns its own header (UserExerciseHistory container).
        return true;
      case `/dashboard/stats/exercise-history/${page.split('/exercise-history/')[1]}`:
        // V2 detail page (UserExerciseDetailPage) owns its own breadcrumb +
        // PageHead, so suppress the legacy title for any deep id route.
        return true;
      case '/dashboard/messages':
        // V2 page owns its own header (MessagesPage uses <PageHead>).
        return true;
      // V2 admin library pages own their own headers via <PageHead>.
      case '/dashboard/admin/library/meal-plan':
      case '/dashboard/admin/library/workout-plans':
      case '/dashboard/admin/library/workout-program':
        return true;
      case `/dashboard/admin/library/meal-plan/${page.split('/meal-plan/')[1]}`:
        // V2 page (pages/adminDashboard/mealPlanTemplate.js) owns its own
        // header via <PageHead>; suppress the legacy title here.
        return true;
      case `/dashboard/admin/clients/${page.split('/')[4]}/edit-meal-plan`:
        return {
          title: 'Client mealplan',
          subtitle: this.props.userMealplan && (
            <p>
              Viewing meal plan for{' '}
              <span style={{ fontWeight: '600' }}>
                {this.props.userMealplan.user.name}{' '}
                {this.props.userMealplan.user.lastName}
              </span>
              .
            </p>
          ),
        };
      case `/dashboard/admin/clients/${page.split('/')[4]}/food-log`: {
        const currentClientId = page.split('/')[4];
        const clientProfile = this.props.clientProfile;
        const clients = this.props.onsiteClients || [];
        const currentClient = clientProfile || clients.find(c => c.user?._id === currentClientId);
        
        const clientName = currentClient?.user 
          ? `${currentClient.user.name || ''} ${currentClient.user.lastName || ''}`.trim()
          : 'Client';

        return {
          title: 'Compliance History',
          subtitle: (
            <p>
              Viewing compliance data for{' '}
              <span style={{ fontWeight: '600' }}>{clientName}</span>
            </p>
          ),
          actions: clients.length > 0 ? [
            {
              custom: (
                <Select
                  showSearch
                  style={{ width: 250 }}
                  placeholder="Switch client..."
                  optionFilterProp="label"
                  value={currentClientId}
                  onChange={(userId) => {
                    if (this.props.history) {
                      this.props.history.push(`/dashboard/admin/clients/${userId}/food-log`);
                    } else {
                      window.location.href = `/dashboard/admin/clients/${userId}/food-log`;
                    }
                  }}
                  filterOption={(input, option) => {
                    // Safely handle undefined label
                    if (!option || !option.label) return false;
                    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  }}
                >
                  {clients
                    .filter(client => client && client.user) // Filter out null/undefined clients first
                    .map((client) => {
                      const fullName = `${client.user.name || ''} ${client.user.lastName || ''}`.trim();
                      const email = client.user.email || '';
                      const label = `${fullName} ${email && `(${email})`}`.trim();
                      return (
                        <Option key={client.user._id} value={client.user._id} label={label}>
                          {label}
                        </Option>
                      );
                    })}
                </Select>
              )
            }
          ] : []
        };
      }
      case `/dashboard/admin/clients/${page.split('/')[4]}/profile`:
        return {
          title: '',
        };
      // Trainer-edits-client meal plan editor. The legacy `/profile/program`
      // URL is kept as a back-compat alias and gets the same title — both
      // mount the same `AdminClientProgram` editor (the workout-program
      // misnomer is preserved in the URL only for old bookmark support).
      case `/dashboard/admin/clients/${page.split('/')[4]}/profile/meal-plan`:
      case `/dashboard/admin/clients/${page.split('/')[4]}/profile/program`: {
        const u = this.props.clientProfile?.user;
        const fullName = u
          ? [u.name, u.lastName].filter(Boolean).join(' ').trim()
          : '';
        return {
          title: 'Meal Plan',
          subtitle: fullName ? (
            <p>
              Editing meal plan for{' '}
              <span style={{ fontWeight: 600 }}>{fullName}</span>.
            </p>
          ) : (
            'Edit the weekly meals, macro targets, and food preferences for this client.'
          ),
        };
      }
      case '/dashboard/settings':
      case '/dashboard/settings/account':
      case '/dashboard/settings/integrations':
      case '/dashboard/settings/billing':
        // V2 settings.js owns its own header.
        return true;
      case '/dashboard/admin':
        // V2 trainer home owns its own header (AdminTrainerHomePage)
        // including the quick-actions row.
        return true;
      case '/dashboard/admin/clients':
        // V2 page owns its own header (AdminClientsPageV2) including the
        // Broadcast + Invite client buttons.
        return true;
      case '/dashboard/profile':
        // V2 page owns its own header via <PageHead>. Returning `true`
        // opts out of the legacy TitleSection so we don't render two
        // titles stacked on top of each other.
        return true;
      // V2 admin pages own their own headers via <PageHead> + actions.
      case '/dashboard/admin/library/workouts':
      case '/dashboard/admin/library/exercises':
      case '/dashboard/admin/assessments':
        return true;
      default: {
        if (isAssessmentsPage) {
          return {
            title: 'Assessments',
            subtitle: 'View default assessments and create your own to assign to clients.',
            actions: [
              {
                text: 'Create New',
                type: 'primary',
                call: () => {
                  this.props.dispatch({
                    type: TOGGLE_CREATE_ASSESSMENT_MODAL,
                    value: true,
                  });
                },
              },
            ],
          };
        }
        if (pathMatch) {
          // V2 page owns its own header (UserWorkoutsPage).
          return true;
        }
        return true;
      }
    }
  };

  renderComponent = () => {
    const page = this.props.location.pathname;
    if (page === '/dashboard/stats/progress') {
      return (
        <Switch
          className='table-mode-switch'
          onChange={() => this.props.setStatMode(!this.props.tableMode)}
          checked={this.props.tableMode}
          checkedChildren='Graph'
          unCheckedChildren='Table'
        />
      );
    }
  };

  renderMenuItems = (menuItems) => {
    return (
      <Menu className='nav-bar-menu' onClick={(e) => this.handleMenuClick(e)}>
        {menuItems.map((item) => (
          <Menu.Item key={item.key}>{item.text}</Menu.Item>
        ))}
      </Menu>
    );
  };

  renderActions = () => {
    const actions =
      this.renderTitleSection().actions &&
      this.renderTitleSection().actions.length > 0;

    return (
      this.renderTitleSection().actions &&
      this.renderTitleSection().actions.map((action, i) => {
        // Handle custom React components
        if (action.custom) {
          return <React.Fragment key={i}>{action.custom}</React.Fragment>;
        }
        
        if (action.type === 'primary' || action.type === 'secondary') {
          return (
            <Button
              className={`item-${i} ${actions && 'add-margin-top'}`}
              key={i}
              type={action.type}
              onClick={() => action.call()}
            >
              {action.text}
            </Button>
          );
        } else if (action.type === 'dropdown') {
          return (
            <Dropdown
              className={`item-${i} ${actions && 'add-margin-top'}`}
              overlay={this.renderMenuItems(action.menuItems)}
              trigger={['click']}
            >
              <Button
                className='flex flex-center-aligned justify-center'
                type='secondary'
              >
                <p className='mr-05'>Actions</p>
              </Button>
            </Dropdown>
          );
        }
        return null;
      })
    );
  };

  render() {
    const page = this.props.location.pathname;
    const titleSection = this.renderTitleSection();
    
    // Handle case where renderTitleSection returns true (default case)
    if (titleSection === true) {
      return null;
    }
    // Default-case fallback: any /dashboard/admin/assessments/* deep
    // route also collapses (covers the create/edit detail screens).
    if (page.startsWith('/dashboard/admin/assessments/')) {
      return null;
    }
    
    const hasTitle = titleSection && titleSection.title && 
      (typeof titleSection.title === 'string' ? titleSection.title.trim() !== '' : !!titleSection.title);
    const hasSubtitle = titleSection && titleSection.subtitle && 
      (typeof titleSection.subtitle === 'string' ? titleSection.subtitle.trim() !== '' : !!titleSection.subtitle);
    const hasActions = titleSection && titleSection.actions && titleSection.actions.length > 0;
    
    // Remove container completely if no title, no subtitle, and no actions
    if (!hasTitle && !hasSubtitle && !hasActions) {
      return null;
    }
    
    return (
      <div
        className={`main-page-title-container flex space-between ${
          page.includes('/dashboard/home') ? 'no-margin' : ''
        }`}
      >
        <div style={{ width: '100%' }}>
          <div className='title-section-content'>
            <div>
              <p className='main-page-title'>
                {titleSection.title || ''}
              </p>
              <p className='main-page-subtitle'>
                {titleSection.subtitle || ''}
              </p>
            </div>
            <div className='title-header-btn-container'>
              {this.renderActions()}
            </div>

            {/* {this.renderComponent()} */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tableMode: state.global.tableMode,
    userMealplan: state.admin.userMealplan,
    profile: state.profile.profile,
    clientProfile: state.admin.clientProfile,
    onsiteClients: state.profile.onsiteClients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    setStatMode: (tableMode) => {
      return dispatch({
        type: SET_STAT_VIEW_MODE,
        tableMode,
      });
    },
    handleCarbCyclingModalOpen: (isOpen) =>
      dispatch(handleCarbCyclingModalOpen(isOpen)),
    toggleCreateExerciseModal: (value) =>
      dispatch({
        type: TOGGLE_CREATE_EXERCISE_MODAL,
        value,
      }),
    toggleCreateUserModal: (value) =>
      dispatch({
        type: TOGGLE_CREATE_USER_MODAL,
        value,
      }),
    toggleCreateWorkoutModal: (value) =>
      dispatch({
        type: TOGGLE_CREATE_WORKOUT_MODAL,
        value,
      }),
    toggleCreateAssessmentModal: (value) =>
      dispatch({
        type: TOGGLE_CREATE_ASSESSMENT_MODAL,
        value,
      }),
    toggleWorkoutProgramModal: (value) =>
      dispatch({
        type: TOGGLE_WORKOUT_PROGRAM_MODAL,
        value,
      }),
    setIsExerciseEdit: (value) =>
      dispatch({
        type: SET_IS_EXERCISE_EDIT,
        value,
      }),
    clearEditExercise: () =>
      dispatch({
        type: CLEAR_EDIT_EXERCISE,
      }),
    setIsWorkoutEdit: (value) =>
      dispatch({
        type: SET_IS_WORKOUT_EDIT,
        value,
      }),
    clearEditWorkout: () =>
      dispatch({
        type: CLEAR_EDIT_WORKOUT,
      }),
    resetWorkoutLocalState: () =>
      dispatch({
        type: RESET_WORKOUT_LOCAL_STATE,
      }),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TitleSection));
